import { AnyAction } from 'redux';
import {
  DirectionsCacheState,
  directionsCacheService,
} from '../../services/directionsCacheService';
import { CacheDirectionsPayload } from '../actions/directionsCacheActions';
import {
  CACHE_DIRECTIONS_RESULT,
  CLEAN_EXPIRED_CACHE_ENTRIES,
  CLEAR_DIRECTIONS_CACHE,
  INVALIDATE_DIRECTIONS_CACHE_FOR_TICKET,
  SYNC_TICKET,
  REMOVE_TICKET,
} from '../../constants/actionConstants';

/**
 * Reducer for managing directions cache state
 */
const directionsCache = (
  state: DirectionsCacheState = {},
  action: AnyAction,
): DirectionsCacheState => {
  switch (action.type) {
    case CACHE_DIRECTIONS_RESULT: {
      const { cacheKey, entry } = action.payload as CacheDirectionsPayload;
      return {
        ...state,
        [cacheKey]: entry,
      };
    }

    case CLEAN_EXPIRED_CACHE_ENTRIES: {
      return directionsCacheService.cleanExpiredEntries(state);
    }

    case INVALIDATE_DIRECTIONS_CACHE_FOR_TICKET: {
      const { ticketId } = action.payload as { ticketId: string };
      if (!ticketId) {
        return state;
      }
      return directionsCacheService.invalidateCacheForTicket(state, ticketId);
    }

    case SYNC_TICKET: {
      // When a ticket is synced (updated), invalidate its cache entry
      const ticket = action.payload as { id?: string | number };
      if (!ticket?.id) {
        return state;
      }
      return directionsCacheService.invalidateCacheForTicket(state, ticket.id.toString());
    }

    case REMOVE_TICKET: {
      // When a ticket is removed (closed), invalidate its cache entry
      const ticket = action.payload as { id?: string | number };
      if (!ticket?.id) {
        return state;
      }
      return directionsCacheService.invalidateCacheForTicket(state, ticket.id.toString());
    }

    case CLEAR_DIRECTIONS_CACHE: {
      return {};
    }

    default:
      return state;
  }
};

export default directionsCache;
